export { extractPackageFile } from './extract';

export const defaultConfig = {
  fileMatch: ['(^|/)kustomization\\.yaml'],
};
